import React from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'danger' | 'ghost';

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  loading?: boolean;
}

function classes(variant: ButtonVariant, disabled?: boolean, loading?: boolean): string {
  const base = 'inline-flex items-center gap-2 px-3 py-2 rounded-md transition-colors select-none';
  const map: Record<ButtonVariant, string> = {
    primary: 'bg-[var(--primary-600)] text-white hover:bg-[var(--primary-700)] active:bg-[var(--primary-800)]',
    secondary: 'text-[var(--primary-700)] hover:bg-[var(--primary-50)]',
    danger: 'bg-red-600 text-white hover:bg-red-700 active:bg-red-800',
    ghost: 'text-slate-700 hover:bg-slate-100',
  };
  const disabledCls = 'opacity-50 pointer-events-none';
  return [base, map[variant], (disabled || loading) ? disabledCls : ''].filter(Boolean).join(' ');
}

export const Button: React.FC<ButtonProps> = ({ variant = 'secondary', disabled, loading, className, children, ...rest }) => {
  return (
    <button
      className={classes(variant, disabled, loading) + (className ? ' ' + className : '')}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...rest}
    >
      {loading && (
        <span
          className="inline-block w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"
          aria-hidden="true"
          role="status"
          aria-label="Lädt"
          data-testid="button-spinner"
        />
      )}
      <span className={loading ? 'opacity-90' : ''}>{children}</span>
    </button>
  );
};
